if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('[data-header-bar]');
        this.burger = this.querySelector('[data-header-burger]');
        this.drawer = this.querySelector('[data-header-drawer]');
        this.megaToggle = this.querySelector('[data-header-mega-toggle]');
        this.mega = this.querySelector('[data-header-mega]');

        this.setHeight();
        window.addEventListener('resize', () => this.setHeight());

        if (this.burger && this.drawer) {
          this.burger.addEventListener('click', () => this.toggleDrawer());
        }

        if (this.megaToggle && this.mega) {
          this.megaToggle.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleMega();
          });
          document.addEventListener('click', (event) => {
            if (!this.mega.hidden && !this.contains(event.target)) this.closeMega();
          });
        }

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeMega();
            this.closeDrawer();
          }
        });

        window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
          if (event.matches) this.closeDrawer();
          else this.closeMega();
        });
      }

      setHeight() {
        if (!this.bar) return;
        document.documentElement.style.setProperty('--header-height', this.bar.offsetHeight + 'px');
      }

      toggleDrawer() {
        if (this.drawer.hidden) this.openDrawer();
        else this.closeDrawer();
      }

      openDrawer() {
        this.closeMega();
        this.setHeight();
        this.drawer.hidden = false;
        this.burger.setAttribute('aria-expanded', 'true');
        this.burger.classList.add('site-header__burger--on');
        document.documentElement.classList.add('site-header-drawer-open');
      }

      closeDrawer() {
        if (!this.drawer || this.drawer.hidden) return;
        this.drawer.hidden = true;
        this.burger.setAttribute('aria-expanded', 'false');
        this.burger.classList.remove('site-header__burger--on');
        document.documentElement.classList.remove('site-header-drawer-open');
      }

      toggleMega() {
        if (this.mega.hidden) this.openMega();
        else this.closeMega();
      }

      openMega() {
        this.mega.hidden = false;
        this.megaToggle.setAttribute('aria-expanded', 'true');
        this.megaToggle.classList.add('site-header__nav-button--open');
      }

      closeMega() {
        if (!this.mega || this.mega.hidden) return;
        this.mega.hidden = true;
        this.megaToggle.setAttribute('aria-expanded', 'false');
        this.megaToggle.classList.remove('site-header__nav-button--open');
      }
    }
  );
}
